import http from "../plugins/Axios";

export default {
  state: {
    accessToView: true,
  },
  getters: {
    accessToView: (state) => state.accessToView,
  },
  mutations: {
    enableAccessToView: (state) => (state.accessToView = true),
    disableAccessToView: (state) => (state.accessToView = false),
  },
  actions: {
    async login(_, payload) {
      return new Promise((resolve, reject) => {
        http
          .post("authenticate", payload)
          .then(({ data: { sessionToken, expiresIn, refreshToken } }) => {
            resolve({ sessionToken, expiresIn, refreshToken });
          })
          .catch(reject);
      });
    },
  },
};
